import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  host: {
    'class': 'page__container loading'
  },
})
export class LoadingComponent implements OnInit {

  /**
   * Constructor
   */

  public logoUrl:string;

  constructor() {
    this.logoUrl = environment.ASSETS_SERVER+environment.LOGO.SPLASH;
  }

  /**
   * On init
   */
  ngOnInit():void {

  }

}
